export const _date = {
  "-1": "Yesterday",
  0: "Today",
  1: "Tomorrow",
};

export const _astroContentKey = {
  0: "relationship",
  1: "career",
  2: "health",
};
